import React, {useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, Switch, Route, useParams } from 'react-router-dom'
import { BreadcrumbPortal, Breadcrumb, HeaderBreadcrumb } from "../common/Breadcrumb"
import Search  from '../common/Search'
import Header from '../header/Header'
import FolderProduct from '../catalogue/nodes/FolderProduct'
import ProductCard from '../catalogue/nodes/ProductCard'
import { articlesApi } from '../../api/articlesApi'
import { mssgs } from '../../constantes/mssgs'
import NullMssg from '../common/NullMssg'
import FinalProductContainer from '../final-product/FinalProductConainer'

// Nivel 1. Categorias
const NodesCataloguePresentacion = (props) => {
    const id = props.idPresentation

    const history = useHistory()
    const allCategories = useSelector(state => state.categories)
    const [items, setItems] = useState(allCategories)

    const onChangeSearch = value => {
        const newItems = allCategories.filter(item => 
            item.nombre.toLowerCase().includes(value.toLowerCase())  )
        setItems(newItems)
    }

   const route = () => {
        return `/presentacion/añadirProductos/${id}/catálogo/categoria/:id`
   }
   const toRoute = () => {
        return `/presentacion/añadirProductos/${id}/catálogo/categoria/`
   }
   const firstbreadCrumb = () => {
        return   `/presentacion/añadirProductos/${id}/catálogo`
   }

    return (
        <>
            <Breadcrumb to={firstbreadCrumb()}> Categorias </Breadcrumb>
            <Switch>
                
                <Route path= {route()} render={(props) => <ProductsOfACategory  idPresentation={id} {...props} />}  />
                <Route>
                    <Header
                        text={"Añadir productos a la presentación"}
                        route={() => history.goBack()}
                        backBtn={true}
                    />
                    <div className="filter__wrap-right mb-80">
                        <HeaderBreadcrumb>
                            <BreadcrumbPortal />
                        </HeaderBreadcrumb>
                        <div className="filter__wrap-right">
                            <Search
                                onChangeSearch={onChangeSearch}
                                placeholder="Buscar productos..."
                            />
                        </div>
                    </div>
                    <div className="frameless">
                        {
                            items.length > 0 ?
                                <div className="btn-catalogue-wrapper">
                                    {
                                        items.map((item,i) => (
                                            <div key={i}>
                                                    { 
                                                        (item.isArticuloFinal !== null && item.isArticuloFinal) 
                                                        ? < ProductCard item={item} pathname={toRoute() + item.id_TipoCategoria} /> 
                                                        : < FolderProduct item={item} pathname={toRoute() + item.id_TipoCategoria} />
                                                    }
                                            </div>
                                            ))
                                    } 
                                </div>
                            : <table style={{width: "100%"}}><tbody><NullMssg mssg= {mssgs.NO_HAY_PRODUCTOS}/></tbody></table>
                        }
                    </div>
                </Route>
            </Switch>
        </>
    )
}

// Nivel 2:  Productos de una categoria 
const ProductsOfACategory = (props) => {

    const match = props.match
    const id = props.idPresentation

    const history = useHistory()
    const allCategories = useSelector(state => state.categories)

    const [items, setItems] = useState([])
    const [data, setData] = useState([])


    const CATEGORY_BY_ID = allCategories.reduce(
        (accumulator, category) => ({
          ...accumulator,
          [category.id_TipoCategoria]: category
        }),
        {}
      )

    const category = CATEGORY_BY_ID[match.params.id]

    useEffect(() =>{
        searchItemsNextNode()
    },[])

    const searchItemsNextNode = async () => {
        try {
            const match = props.match
            const response = await articlesApi.getArticlesByCategoryId(match.params.id)
            setData(response.data)
            setItems(response.data)
        } catch {
            history.goBack()
        }
    }

    const onChangeSearch = value => {
        const newItems = data.filter(item => 
            item.nombre.toLowerCase().includes(value.toLowerCase()))
        setItems(newItems)
    }

    return (
      <>
        <Breadcrumb to={match.url}>{category.nombre}</Breadcrumb>
        <Switch>
            <Route path={`${match.url}/product/:idProduct/:nombre`}  render={(props) => <Products  idPresentation={id} {...props} />} />
            <Route path={`${match.url}/final/:finalProduct`}  render={(props) => <FinalProduct  idPresentation={id} {...props} />} />
            <Route>
                <Header
                    text={"Añadir productos a la presentación"}
                    route={() => history.goBack()}
                    backBtn={true}
                />
                <div className="filter__wrap-right mb-80">
                    <HeaderBreadcrumb>
                        <BreadcrumbPortal />
                    </HeaderBreadcrumb>
                    <div className="filter__wrap-right">
                        <Search
                            onChangeSearch={onChangeSearch}
                            placeholder="Buscar productos..."
                        />
                    </div>
                </div>
                <div className="frameless">
                    {
                        items.length > 0 ?
                            <div className="btn-catalogue-wrapper">
                                {
                                    items.filter(item => !item.isArticuloFinal).map((item,i) => (
                                        <div key={i}>
                                            <FolderProduct item={item} pathname={`${match.url}/product/${item.id_Articulo}/${item.nombre.replace(/ *\([^)]*\) */g, "")}`}/>
                                        </div>
                                    ))
                                }
                                {
                                    items.filter(item => item.isArticuloFinal).map((item,i) => (
                                        <div key={i}>
                                            <ProductCard item={item} pathname={`${match.url}/final/${item.id_Articulo}`}/>
                                        </div>
                                    ))
                                }
                            </div>
                            : <table style={{width: "100%"}}><tbody><NullMssg mssg= {mssgs.NO_HAY_PRODUCTOS}/></tbody></table>
                    }
                </div>
          </Route>
        </Switch>
      </>
    )
}

// Nivel 2 + N : Productos de productos
const Products = (props) => {
    const id = props.idPresentation
    const match = props.match
    const nombre = match.params.nombre

    const history = useHistory()
    const [items, setItems] = useState([])
    const [data, setData] = useState([])

    useEffect(() =>{
        searchItemsNextNode()
    },[])

    const searchItemsNextNode = async () => {
        try {
            const response = await articlesApi.getArticlesOfAFatherId(match.params.idProduct)
            setData(response.data)
            setItems(response.data)
        } catch {
            history.goBack()
        }
    }

    const onChangeSearch = value => {
        const newItems = data.filter(item => 
            item.nombre.toLowerCase().includes(value.toLowerCase())  )
        setItems(newItems);
    }

    return(
        <>
            <Breadcrumb to={match.url} >{nombre}</Breadcrumb>
            <Switch>
                <Route path={`${match.url}/product/:idProduct/:nombre`} render={(props) => <Products  idPresentation={id} {...props} />}  />
                <Route path={`${match.url}/final/:finalProduct`} render={(props) => <FinalProduct  idPresentation={id} {...props} />} />
                <Route>
                    <Header
                        text={"Añadir productos a la presentación"}
                        route={() => history.goBack()}
                        backBtn={true}
                    />
                    <div className="filter__wrap-right mb-80">
                        <HeaderBreadcrumb>
                            <BreadcrumbPortal />
                        </HeaderBreadcrumb>
                        <div className="filter__wrap-right ">
                            <Search
                                onChangeSearch={onChangeSearch}
                                placeholder="Buscar productos..."
                            />
                        </div>
                    </div>
                    <div className="frameless">
                        {
                            items.length > 0 ? 
                                <div className="btn-catalogue-wrapper">
                                    {
                                        items.filter(item => !item.isArticuloFinal).map((item,i) => (
                                            <div key={i}>
                                                <FolderProduct item={item} pathname={`${match.url}/product/${item.id_Articulo}/${item.nombre.replace(/ *\([^)]*\) */g, "")}`}/>
                                            </div>
                                        ))
                                    }
                                    {
                                        items.filter(item => item.isArticuloFinal).map((item,i) => (
                                            <div key={i}>
                                                <ProductCard item={item} pathname={`${match.url}/final/${item.id_Articulo}`}/> 
                                            </div>
                                        ))
                                    }
                                </div>
                                :  <table style={{width: "100%"}}><tbody><NullMssg mssg= {mssgs.NO_HAY_PRODUCTOS}/></tbody></table>
                        }
                    </div>
                </Route>
            </Switch>
        </>
    )
}

const FinalProduct = (props) => {
    const idPresentation = props.idPresentation
    const match = props.match

    const history = useHistory()
    const [item, setItem] = useState('')

    useEffect(() =>{
        getInfoFinalProduct()
    },[])

    const getInfoFinalProduct = async () => {
        try {
            const response = await articlesApi.getInfoArticle(match.params.finalProduct)
            setItem(response.data)
        } catch {
            history.goBack()
        }
    }
    
    return (
        <>
            <Breadcrumb to={match.url} > </Breadcrumb>
            <Switch>
                <Route>
                    <Header
                        text={"Añadir productos a la presentación"}
                        route={() => history.goBack()}
                        backBtn={true}
                    />
                    <div className="filter__wrap-right mb-80">
                        <HeaderBreadcrumb>
                            <BreadcrumbPortal />
                        </HeaderBreadcrumb>
                    </div>
                    <FinalProductContainer item={item} idPresentation={idPresentation} />
                </Route>
            </Switch>
        </>

    )
}

export default NodesCataloguePresentacion